module.exports = __webpack_public_path__ + "img/az.451284ce.svg";